import { NormalizedEmail } from "./types/normalizations.ts";

type ComparableContactDetails = {
  firstName?: string;
  lastName?: string;
  email?: string;
  salutation?: "male" | "female";
};

type NextComparableContactDetails = {
  firstName: string;
  lastName: string;
  email?: string;
  salutation: "male" | "female";
};

const normalizeComparableEmail = (email?: string) =>
  email ? NormalizedEmail.parse(email) : undefined;

export const contactDetailsRequireReclassification = (
  previous: ComparableContactDetails | undefined,
  next: NextComparableContactDetails,
) =>
  !previous ||
  previous.firstName !== next.firstName ||
  previous.lastName !== next.lastName ||
  normalizeComparableEmail(previous.email) !==
    normalizeComparableEmail(next.email) ||
  previous.salutation !== next.salutation;
